export default "__VITE_ASSET__791e3ef2__"